import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const DeleteConfirmDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1,
          minWidth: 320,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 18,
          fontWeight: 600,
          color: "#1E293B",
          pb: 1,
        }}
      >
        Delete Attachment?
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, color: "#64748B" }}>
          Are you sure you want to delete this attachment? This action cannot
          be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onClose}
          sx={{
            px: 2.5,
            py: 1,
            borderRadius: 2.5,
            fontSize: 13,
            fontWeight: 600,
            color: "#64748B",
            bgcolor: "#F1F5F9",
            textTransform: "none",
            "&:hover": {
              bgcolor: "#E2E8F0",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          sx={{
            px: 2.5,
            py: 1,
            borderRadius: 2.5,
            fontSize: 13,
            fontWeight: 600,
            color: "#FFFFFF",
            bgcolor: "#EF4444",
            textTransform: "none",
            "&:hover": {
              bgcolor: "#DC2626",
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
